import { ClientFlags, SaveClientFlags } from '@sdk/authentication/types';
import getNowDate from '@sdk/utils/getNowDate';

const WAIT_DAYS = 1;

export enum ExternalRateServices {
  g2 = 'g2',
  shopify = 'shopify',
  capterra = 'capterra',
}

export function shouldDisplayExternalRate(
  clientFlags: ClientFlags,
  hasShopifyIntegration: boolean
): boolean {
  const date = clientFlags.externalRate?.countdownDate;
  if (date && getExternalRateService(clientFlags, hasShopifyIntegration)) {
    const countdownDays = (getNowDate().getTime() - new Date(date).getTime()) / 1000 / 3600 / 24;
    return countdownDays >= WAIT_DAYS;
  }

  return false;
}

export function setCountdownDate(
  clientFlags: ClientFlags,
  saveFlags: SaveClientFlags,
  clearDate?: boolean
): void {
  const externalRate = clientFlags.externalRate || {};
  saveFlags({
    flags: {
      externalRate: {
        ...externalRate,
        countdownDate: clearDate ? null : getNowDate().toISOString(),
      },
    },
  });
}

export function setServiceRated(
  service: ExternalRateServices,
  clientFlags: ClientFlags,
  saveFlags: SaveClientFlags
): void {
  const externalRate = clientFlags.externalRate || {};
  saveFlags({
    flags: {
      externalRate: {
        ...externalRate,
        countdownDate: null,
        [`${service}Rated`]: true,
      },
    },
  });
}

export function isServiceRated(service: ExternalRateServices, clientFlags: ClientFlags): boolean {
  return clientFlags.externalRate?.[`${service}Rated`];
}

export function getExternalRateService(
  clientFlags: ClientFlags,
  hasShopifyIntegration: boolean
): ExternalRateServices | null {
  if (hasShopifyIntegration && !isServiceRated(ExternalRateServices.shopify, clientFlags)) {
    return ExternalRateServices.shopify;
  }

  const capterraRated = isServiceRated(ExternalRateServices.capterra, clientFlags);
  const g2Rated = isServiceRated(ExternalRateServices.g2, clientFlags);

  if (g2Rated && capterraRated) {
    return null;
  }

  if (g2Rated) {
    return ExternalRateServices.capterra;
  }

  if (capterraRated) {
    return ExternalRateServices.g2;
  }

  return Math.round(Math.random()) ? ExternalRateServices.g2 : ExternalRateServices.capterra;
}
